import React, { useEffect, useState } from "react";
import Carousel from "react-elastic-carousel";
import MovieBox from "../components/MovieBox";

const Upcoming = () => {
  const API_UPCOMING =
    "https://api.themoviedb.org/3/movie/upcoming?api_key=a7c761395a54cf211d4a190dbb18b4a5";
  const breakPoints = [
    { width: 1, itemsToShow: 2 },
    { width: 500, itemsToShow: 3 },
    { width: 768, itemsToShow: 4 },
    { width: 1200, itemsToShow: 6 },
  ];

  const [moviePopular, setMoviePopular] = useState([]);

  useEffect(() => {
    fetch(API_UPCOMING)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
        setMoviePopular(data.results);
      });
  }, []);
  return (
    <div className="h-[400px] w-full  mx-auto flex flex-col dark:text-black text-white">
      <div className="px-[80px]">
        {/* <h3 className="md:decoration-dotted">Latest Movies</h3> */}
        <h3 className="mx-auto my-3">MOVIES UPCOMING</h3>
      </div>
      <div className="grid lg:grid-cols-6 gap-4 sm:grid-cols-1 md:grid-cols-4">
        <Carousel breakPoints={breakPoints} className="flex absolute">
          {moviePopular.map((movieReq) => (
            <MovieBox key={movieReq.id} {...movieReq} />
          ))}
        </Carousel>
      </div>
    </div>
  );
};

export default Upcoming;
